(() => {
  const roots = document.querySelectorAll('[data-campaign-root]');
  if (!roots.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  roots.forEach((root) => {
    // Read the product metafield before draft/expired campaigns remove transaction links.
    if (root.classList.contains('ms-campaign--product_promotion')) {
      const abvs = new Map([...root.querySelectorAll('[data-campaign-product-details] [data-product-handle]')]
        .map((item) => [item.dataset.productHandle, item.dataset.productAbv]));
      root.querySelectorAll('.ms-campaign-offer-card').forEach((card) => {
        const subtitle = card.querySelector('.ms-campaign-offer-card__subtitle');
        const link = card.querySelector('.ms-campaign-conversion a[href]');
        if (!subtitle || !link || subtitle.querySelector('.ms-campaign-product-abv')) return;
        let productUrl;
        try { productUrl = new URL(link.href, window.location.href); } catch (_error) { return; }
        const path = productUrl.pathname.match(/\/products\/([a-z0-9-]+)$/);
        if (productUrl.origin !== window.location.origin || !path) return;
        const raw = abvs.get(path[1]);
        if (typeof raw !== 'string') return;
        // The existing single-line field contains values such as "40% Alc/Vol".
        const match = raw.trim().match(/^(\d+(?:\.\d+)?)\s*(?:%\s*(?:ABV|Alc\s*\/\s*Vol)?|ABV)?$/i);
        if (!match || Number(match[1]) > 100 || !Number.isFinite(Number(match[1]))) return;
        const value = Number(match[1]) === 0 ? '0.0' : match[1];
        const abv = document.createElement('span');
        abv.className = 'ms-campaign-product-abv';
        abv.textContent = `${subtitle.textContent.trim() ? ' · ' : ''}${value}% ABV`;
        subtitle.append(abv);
      });
    }

    if (root.dataset.campaignChrome === 'minimal') {
      document.body.classList.add('ms-campaign-minimal-chrome');
    }

    const disableBodyTransactions = () => {
      const body = root.querySelector('.ms-campaign-body');
      if (!body) return;
      body.setAttribute('data-campaign-transactions-disabled', '');
      body.querySelectorAll('.ms-campaign-conversion, .ms-campaign-coupon').forEach((control) => {
        if (root.dataset.campaignStatus === 'draft' && root.dataset.campaignPreviewContact === 'true' && control.matches('.ms-campaign-conversion') && control.querySelector('a[href="#venue-hire-enquiry"]')) return;
        control.remove();
      });
    };

    if (root.dataset.campaignStatus !== 'active') disableBodyTransactions();

    if (root.classList.contains('ms-campaign--product_promotion')) {
      const formatAud = (cents) => new Intl.NumberFormat('en-AU', {
        style: 'currency', currency: 'AUD', minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
      const toCents = (text) => Math.round(Number(text?.replace(/[^\d.]/g, '') || NaN) * 100);
      root.querySelectorAll('.ms-campaign-offer-card').forEach((card) => {
        const original = card.querySelector('.ms-campaign-price-original');
        const current = card.querySelector('.ms-campaign-price');
        const authoredWas = original?.textContent.trim();
        // Text nodes only, so a <small> price suffix (for example "per 700ml") is not read as part of the price.
        const authoredNow = current ? [...current.childNodes].filter((node) => node.nodeType === 3).map((node) => node.textContent).join('') : '';
        const expectedWas = toCents(authoredWas);
        const expectedNow = toCents(authoredNow);
        // A Was price is honest in two cases: the sale is an automatic discount, so the product still costs the Was
        // price; or the sale is a price change, so the product's compare-at price is the Was price and its price is
        // the authored Now price. Returns the amount to show as Was, or null when neither holds (or the Was text is not a price).
        const liveWas = (variant) => {
          if (!original) return variant.price;
          if (!Number.isFinite(expectedWas)) return null;
          if (variant.price === expectedWas) return variant.price;
          if (Number.isFinite(expectedNow) && variant.compare_at_price === expectedWas && variant.price === expectedNow && expectedNow < expectedWas) return variant.compare_at_price;
          return null;
        };
        if (original && current) {
          original.replaceChildren('Was ', Object.assign(document.createElement('del'), { textContent: authoredWas }));
          const now = document.createElement('span');
          now.className = 'ms-campaign-price__label';
          now.textContent = 'Now';
          current.prepend(now);
        }

        const conversion = card.querySelector('.ms-campaign-conversion');
        const link = conversion?.querySelector('a[href]');
        if (!link) return;
        const productUrl = new URL(link.href, window.location.href);
        const variantId = productUrl.searchParams.get('variant');
        if (productUrl.origin !== window.location.origin || !/^\d+$/.test(variantId || '') || !/\/products\/[^/]+$/.test(productUrl.pathname)) return;

        (async () => {
          try {
            const productResponse = await fetch(`${productUrl.pathname}.js`, { credentials: 'same-origin' });
            if (!productResponse.ok) throw new Error('Product unavailable');
            const product = await productResponse.json();
            const variant = product.variants?.find((item) => String(item.id) === variantId);
            if (!variant || !Number.isSafeInteger(variant.price)) throw new Error('Variant unavailable');
            const was = liveWas(variant);
            if (original) original.querySelector('del').textContent = formatAud(was ?? variant.price);

            if (was === null) {
              // Hide the Was too: on a price-change sale the live price is often what the shopper pays, so it must not be struck out.
              original.hidden = true;
              if (current) current.hidden = true;
              const notice = document.createElement('span');
              notice.className = 'ms-campaign-price-alert';
              notice.textContent = 'Price changed. Check the product before ordering.';
              original.closest('.ms-campaign-price-row')?.append(notice);
              return;
            }
            if (root.dataset.campaignRetailCart !== 'true' || root.dataset.campaignStatus !== 'active' || !variant.available) return;

            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'ms-campaign-btn ms-campaign-add-to-cart';
            button.textContent = 'Add to cart';
            const status = document.createElement('p');
            status.className = 'ms-campaign-cart-status';
            status.setAttribute('role', 'status');
            status.hidden = true;
            link.classList.add('ms-campaign-view-product');
            link.textContent = 'View product';
            conversion.prepend(button);
            conversion.append(status);

            button.addEventListener('click', async () => {
              if (root.dataset.campaignStatus !== 'active') return;
              button.disabled = true;
              button.textContent = 'Adding…';
              status.hidden = true;
              let addedToCart = false;
              try {
                const liveResponse = await fetch(`${productUrl.pathname}.js`, { credentials: 'same-origin' });
                if (!liveResponse.ok) throw new Error('Product unavailable');
                const liveProduct = await liveResponse.json();
                const liveVariant = liveProduct.variants?.find((item) => String(item.id) === variantId);
                if (!liveVariant?.available || liveVariant.price !== variant.price || liveWas(liveVariant) !== was || root.dataset.campaignStatus !== 'active') throw new Error('Product changed');
                const cartRoot = window.Shopify?.routes?.root || '/';
                const drawer = document.querySelector('.js-cart-drawer');
                const sections = [document.querySelector('page-header'), drawer].filter((element) => element?.dataset.sectionId);
                const response = await fetch(`${cartRoot}cart/add.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({
                    items: [{ id: Number(variantId), quantity: 1 }],
                    sections: sections.map((element) => element.dataset.sectionId).join(','),
                    sections_url: window.location.pathname
                  })
                });
                if (!response.ok) throw new Error('Cart unavailable');
                addedToCart = true;
                const cart = await response.json().catch(() => ({}));
                if (cart.sections && sections.every((element) => cart.sections[element.dataset.sectionId] && typeof element.updateFromCartChange === 'function')) {
                  sections.forEach((element) => element.updateFromCartChange(cart.sections[element.dataset.sectionId]));
                } else {
                  document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
                }
                // Rebuy listens for the theme's cart-add event and opens its own cart panel.
                if (document.querySelector('#rebuy-cart')) {
                  button.dispatchEvent(new CustomEvent('on:cart:add', {
                    bubbles: true,
                    detail: { variantId: Number(variantId) }
                  }));
                } else if (drawer && typeof drawer.open === 'function') {
                  drawer.open(button);
                } else {
                  window.location.assign(`${cartRoot}cart`);
                }
                button.disabled = false;
                button.textContent = 'Add to cart';
              } catch (_error) {
                status.textContent = addedToCart
                  ? 'Added to cart. Open the cart to review it.'
                  : 'Could not add this item. Open the product to try again.';
                status.hidden = false;
                button.disabled = addedToCart;
                button.textContent = addedToCart ? 'Added to cart' : 'Add to cart';
              }
            });
          } catch (_error) {
            if (original) original.hidden = true;
            if (current) current.hidden = true;
            const notice = document.createElement('span');
            notice.className = 'ms-campaign-price-alert';
            notice.textContent = 'Check the product for its current price and offer.';
            card.querySelector('.ms-campaign-price-row')?.append(notice);
          }
        })();
      });
    }

    const deactivate = (message) => {
      root.dataset.campaignStatus = 'expired';
      root.classList.remove('ms-campaign--active');
      root.classList.add('ms-campaign--expired');
      disableBodyTransactions();
      root.querySelectorAll('.ms-campaign-conversion').forEach((conversion) => conversion.remove());
      root.querySelectorAll('[data-campaign-countdown]').forEach((countdown) => {
        countdown.textContent = message;
        countdown.setAttribute('role', 'status');
      });
    };

    root.querySelectorAll('[data-campaign-countdown]').forEach((countdown) => {
      const endsAt = Date.parse(countdown.dataset.campaignCountdown || '');
      const message = countdown.dataset.campaignExpiredMessage || 'This campaign has ended.';
      if (Number.isNaN(endsAt)) return;

      const time = countdown.querySelector('.ms-campaign-countdown__time');
      const tick = () => {
        const remaining = endsAt - Date.now();
        if (remaining <= 0) {
          deactivate(message);
          return false;
        }
        if (time) {
          const totalSeconds = Math.floor(remaining / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          time.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s remaining`;
        }
        return true;
      };
      if (tick()) {
        const timer = window.setInterval(() => {
          if (!tick()) window.clearInterval(timer);
        }, 1000);
      }
    });

    const videos = Array.from(root.querySelectorAll('[data-campaign-video]'));
    const videoToggle = root.querySelector('[data-campaign-video-toggle]');
    let videosPausedByUser = false;

    const updateVideoToggle = () => {
      if (!videoToggle) return;
      videoToggle.hidden = reducedMotion.matches;
      videoToggle.disabled = reducedMotion.matches;
      if (reducedMotion.matches) videoToggle.setAttribute('aria-hidden', 'true');
      else videoToggle.removeAttribute('aria-hidden');
      videoToggle.setAttribute('aria-pressed', String(videosPausedByUser));
      videoToggle.setAttribute('aria-label', videosPausedByUser ? 'Play background video' : 'Pause background video');
      const pauseIcon = videoToggle.querySelector('[data-campaign-video-pause]');
      const playIcon = videoToggle.querySelector('[data-campaign-video-play]');
      if (pauseIcon) pauseIcon.hidden = videosPausedByUser;
      if (playIcon) playIcon.hidden = !videosPausedByUser;
    };

    const syncVideos = () => {
      videos.forEach((video) => {
        if (reducedMotion.matches || videosPausedByUser) {
          video.pause();
          return;
        }
        const rect = video.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < window.innerHeight;
        if (visible) video.play().catch(() => {});
        else video.pause();
      });
    };

    if (videos.length) {
      if (videoToggle) {
        videoToggle.addEventListener('click', () => {
          videosPausedByUser = !videosPausedByUser;
          updateVideoToggle();
          syncVideos();
        });
        updateVideoToggle();
      }
      const handleMotionPreferenceChange = () => {
        updateVideoToggle();
        syncVideos();
      };
      reducedMotion.addEventListener?.('change', handleMotionPreferenceChange);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(syncVideos, { threshold: 0.05 });
        videos.forEach((video) => observer.observe(video));
      } else {
        window.addEventListener('scroll', syncVideos, { passive: true });
      }
      syncVideos();
    }

    root.querySelectorAll('[data-campaign-reviews]').forEach((carousel) => {
      const track = carousel.querySelector('[data-campaign-reviews-track]');
      const cards = Array.from(carousel.querySelectorAll('[data-campaign-review]'));
      const dots = carousel.querySelector('[data-campaign-reviews-dots]');
      if (!track || !cards.length || !dots) return;

      let page = 0;
      let perPage = 1;

      const render = () => {
        const width = carousel.getBoundingClientRect().width;
        perPage = width >= 900 ? 3 : width >= 560 ? 2 : 1;
        const pageCount = Math.ceil(cards.length / perPage);
        page = Math.min(page, Math.max(0, pageCount - 1));
        const gap = 16;
        const cardWidth = (width - gap * (perPage - 1)) / perPage;
        track.style.transform = `translateX(-${page * (cardWidth + gap) * perPage}px)`;
        cards.forEach((card) => {
          card.style.minWidth = `${cardWidth}px`;
          card.style.width = `${cardWidth}px`;
        });
        dots.replaceChildren();
        for (let index = 0; index < pageCount; index += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ms-campaign-reviews__dot';
          button.setAttribute('aria-label', `Show reviews page ${index + 1}`);
          button.setAttribute('aria-current', String(index === page));
          button.addEventListener('click', () => { page = index; render(); });
          dots.append(button);
        }
      };

      if ('ResizeObserver' in window) {
        let previousPerPage = 0;
        new ResizeObserver(() => {
          const nextPerPage = carousel.getBoundingClientRect().width >= 900 ? 3 : carousel.getBoundingClientRect().width >= 560 ? 2 : 1;
          if (nextPerPage !== previousPerPage) page = 0;
          previousPerPage = nextPerPage;
          render();
        }).observe(carousel);
      } else {
        window.addEventListener('resize', () => { page = 0; render(); });
      }
      render();
    });

    root.querySelectorAll('[data-campaign-stories]').forEach((carousel) => {
      const track = carousel.querySelector('[data-campaign-stories-track]');
      const cards = Array.from(carousel.querySelectorAll('[data-campaign-story]'));
      const dots = carousel.querySelector('[data-campaign-stories-dots]');
      const previous = carousel.querySelector('[data-campaign-stories-prev]');
      const next = carousel.querySelector('[data-campaign-stories-next]');
      if (!track || !cards.length || !dots || !previous || !next) return;

      let active = 0;
      const render = () => {
        track.style.setProperty('--ms-story-index', active);
        cards.forEach((card, index) => {
          card.dataset.active = String(index === active);
          card.dataset.near = String(Math.abs(index - active) === 1);
        });
        previous.disabled = active === 0;
        next.disabled = active === cards.length - 1;
        dots.replaceChildren();
        cards.forEach((_card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ms-campaign-stories__dot';
          dot.setAttribute('aria-label', `Show story ${index + 1}`);
          dot.setAttribute('aria-current', String(index === active));
          dot.addEventListener('click', () => { active = index; render(); });
          dots.append(dot);
        });
      };
      cards.forEach((card, index) => card.addEventListener('click', () => { active = index; render(); }));
      previous.addEventListener('click', () => { active = Math.max(0, active - 1); render(); });
      next.addEventListener('click', () => { active = Math.min(cards.length - 1, active + 1); render(); });
      render();
    });

    root.querySelectorAll('[data-campaign-terms]').forEach((terms) => {
      const toggle = terms.querySelector('[data-campaign-terms-toggle]');
      const label = terms.querySelector('[data-campaign-terms-label]');
      const content = terms.querySelector('[data-campaign-terms-content]');
      if (!toggle || !label || !content) return;

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        terms.dataset.expanded = String(expanded);
        content.hidden = !expanded;
        label.textContent = expanded ? 'Hide terms & conditions' : 'View all terms & conditions';
      });
    });

    root.querySelectorAll('[data-campaign-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const value = button.dataset.campaignCopy || '';
        const statusId = button.getAttribute('aria-describedby');
        const status = statusId ? document.getElementById(statusId) : null;
        try {
          await navigator.clipboard.writeText(value);
          if (status) status.textContent = 'Code copied to clipboard.';
          button.textContent = 'Copied';
        } catch (_error) {
          if (status) status.textContent = 'Copy failed. Select the code and copy it manually.';
        }
      });
    });

    // Jump-to category menu (section_nav module). Last in this setup, so nothing here can stop the countdown or expiry above.
    // The plain #links work on their own; this keeps the headings clear of the sticky header and bar, marks the section in
    // view (aria-current) and, on a phone, scrolls that chip into the row.
    root.querySelectorAll('[data-campaign-section-nav]').forEach((nav) => {
      const list = nav.querySelector('.ms-campaign-section-nav__list');
      const chips = [...nav.querySelectorAll('a[href^="#"]')]
        .map((chip) => ({ chip, target: document.getElementById(chip.getAttribute('href').slice(1)) }))
        .filter((item) => item.target);
      if (!list || !chips.length) return;
      const headerHeight = () => parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height'), 10) || 0;
      const setHeight = () => root.style.setProperty('--ms-campaign-section-nav-h', `${Math.ceil(nav.offsetHeight)}px`);
      setHeight();
      if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(nav);

      let active = null;
      const setActive = (item) => {
        if (item === active) return;
        active?.chip.removeAttribute('aria-current');
        active = item;
        if (!active) return;
        active.chip.setAttribute('aria-current', 'location');
        if (list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: active.chip.offsetLeft - (list.clientWidth - active.chip.offsetWidth) / 2, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      };
      // Current: the last section whose heading has passed under the header and bar, while that section is still on screen.
      // At the foot of the page a short last section can't reach the line, so the last section on screen counts instead.
      const update = () => {
        const line = headerHeight() + nav.offsetHeight + 24;
        const onScreen = (item) => {
          const box = (item.target.closest('section') || item.target).getBoundingClientRect();
          return box.bottom > line && box.top < window.innerHeight;
        };
        const atFoot = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        let current = null;
        chips.forEach((item) => {
          if ((atFoot || item.target.getBoundingClientRect().top <= line) && onScreen(item)) current = item;
        });
        setActive(current);
      };

      // Chip clicks scroll here rather than through the theme's internal-link smooth scroll (main.js
      // internalLinksSmoothScroll), whose fixed offset ignores this bar; the headings' scroll-margin-top keeps them clear.
      // While the page scrolls to the chosen section the chip stays current, instead of stepping through every section passed.
      let settling = 0;
      const settle = () => { window.clearTimeout(settling); settling = 0; update(); };
      nav.addEventListener('click', (event) => {
        const item = chips.find(({ chip }) => chip === event.target.closest('a'));
        if (!item) return;
        event.stopPropagation();
        // Ctrl, Cmd or Shift: let the browser open the link in a new tab or window (the theme handler would cancel that).
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        setActive(item);
        window.clearTimeout(settling);
        settling = window.setTimeout(settle, 1000);
        item.target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        window.history.replaceState(null, '', item.chip.hash);
        if (!item.target.hasAttribute('tabindex')) item.target.setAttribute('tabindex', '-1');
        item.target.focus({ preventScroll: true });
      });
      window.addEventListener('scrollend', () => { if (settling) settle(); });

      let queued = false;
      window.addEventListener('scroll', () => {
        if (queued || settling) return;
        queued = true;
        window.requestAnimationFrame(() => { queued = false; update(); });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();

      // A link straight to a section (#gin) jumps before the theme has measured its sticky header, so the heading can land
      // under it: jump again once the page has loaded. Not on a reload or Back, where the browser restores the shopper's place.
      const navigationType = window.performance?.getEntriesByType?.('navigation')[0]?.type;
      const linked = navigationType === 'reload' || navigationType === 'back_forward' ? null : chips.find(({ chip }) => chip.hash === window.location.hash);
      if (linked) {
        const jump = () => linked.target.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (document.readyState === 'complete') jump();
        else window.addEventListener('load', jump, { once: true });
      }
    });
  });
})();
